import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import Modal from "@/components/modal";
import styles from "@/components/company/companySetupIncompleteModal.module.css";

interface CompanySetupIncompleteModalProps {
  open: boolean;
  companyName: string;
  missingFields: string[];
  onClose: () => void;
  onEditAnchorData: () => void;
}

const CompanySetupIncompleteModal: FC<
  CompanySetupIncompleteModalProps
> = ({ open, companyName, missingFields, onClose, onEditAnchorData }) => {
  const { t } = useTranslation();
  const missingFieldCount = missingFields.length;

  return (
    <Modal
      open={open}
      title={t("company_setup_incomplete_title")}
      cancelButtonText={t("close")}
      submitButtonText={t("company_setup_edit_anchor_data")}
      onClose={onClose}
      onSubmit={onEditAnchorData}
      maxWidth="36rem"
      paperBorderRadius="0.75rem"
      contentClassName={styles.content}
    >
      <div className={styles.warningMessage}>
        <WarningAmberIcon className={styles.warningIcon} />
        <p className={styles.summary}>
          {t("company_setup_missing_summary", {
            name: companyName,
            count: missingFieldCount,
          })}
        </p>
      </div>

      <h3 className={styles.missingFieldsHeading}>
        {t("company_setup_missing_fields_heading", {
          count: missingFieldCount,
        })}
      </h3>
      <ul className={styles.missingFieldList}>
        {missingFields.map((field) => (
          <li key={field} className={styles.missingField}>
            {field}
          </li>
        ))}
      </ul>
    </Modal>
  );
};

export default CompanySetupIncompleteModal;
